<div class="main-content table-page table-page--compact incidencias-board-page denuncias-kanban-page">
  <div class="container-fluid">
    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Código</mat-label>
              <input
                id="busquedaDenuncia"
                aria-label="Código"
                matInput
                type="text"
                [(ngModel)]="busqueda"
                placeholder="DEN-2026-00001"
                (keyup.enter)="cargarKanban()">
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Categoría</mat-label>
              <select
                id="categoriaDenuncia"
                aria-label="Categoría"
                matNativeControl
                [(ngModel)]="id_categoria">
                <option [ngValue]="null">Todas</option>
                <option *ngFor="let cat of categorias" [ngValue]="cat.id_categoria">
                  {{ cat.nombre }}
                </option>
              </select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Fecha inicio</mat-label>
              <input
                id="fechaInicioDenuncia"
                aria-label="Fecha inicio"
                matInput
                readonly
                [max]="fechaFin"
                [matDatepicker]="fechaInicioPicker"
                [(ngModel)]="fechaInicio">
              <mat-datepicker-toggle matSuffix [for]="fechaInicioPicker"></mat-datepicker-toggle>
              <mat-datepicker #fechaInicioPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Fecha fin</mat-label>
              <input
                id="fechaFinDenuncia"
                aria-label="Fecha fin"
                matInput
                readonly
                [min]="fechaInicio"
                [matDatepicker]="fechaFinPicker"
                [(ngModel)]="fechaFin">
              <mat-datepicker-toggle matSuffix [for]="fechaFinPicker"></mat-datepicker-toggle>
              <mat-datepicker #fechaFinPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions denuncias-kanban-page__toolbar-actions">
          <div class="incidencias-board-page__toolbar-summary">
            <span>Total</span>
            <strong>{{ getTotalVisible() }}</strong>
          </div>

          <button
            type="button"
            class="app-form-btn app-form-btn--secondary app-form-btn--compact"
            (click)="irConfiguracion()">
            Correos
          </button>

          <button
            type="button"
            class="app-form-btn app-form-btn--secondary app-form-btn--compact"
            (click)="limpiarFiltros()">
            Limpiar
          </button>

          <button
            type="button"
            class="app-form-btn app-form-btn--primary app-form-btn--compact"
            (click)="cargarKanban()"
            [disabled]="cargando">
            {{ cargando ? 'Cargando...' : 'Filtrar' }}
          </button>
        </div>
      </div>

      <div class="incidencias-board-page__board-shell">
        <div class="incidencias-board-page__drag-hint" *ngIf="!cargando">
          <i class="material-icons">pan_tool_alt</i>
          <span>Arrastra para ver más columnas</span>
        </div>

        <div class="table-page__empty-state denuncias-kanban-page__loading" *ngIf="cargando">
          <i class="material-icons">hourglass_top</i>
          <p>Cargando denuncias...</p>
        </div>

        <div class="incidencias-board-page__board" *ngIf="!cargando">
          <article
            class="incidencias-board-page__column"
            *ngFor="let col of columnas; trackBy: trackByColumn; let i = index"
            [style.--incidencia-column-color]="col.color"
            (dragover)="onDragOver($event)"
            (drop)="onDrop($event, i)">
            <header
              class="incidencias-board-page__column-header"
              [style.backgroundColor]="col.color">
              <div class="incidencias-board-page__column-title">
                <span class="material-icons">{{ col.icono }}</span>
                <div class="incidencias-board-page__column-title-text">
                  <strong>{{ col.titulo }}</strong>
                  <small>{{ col.lista.length }}</small>
                </div>
              </div>
            </header>

            <div class="incidencias-board-page__column-pager denuncias-kanban-page__column-pager"
              *ngIf="totalPaginas(col) > 1">
              <span class="denuncias-kanban-page__rango">
                {{ rangoInicio(i) }}–{{ rangoFin(i) }} de {{ col.lista.length }}
              </span>
              <div class="table-page__pager incidencias-board-page__pager">
                <button type="button" class="table-page__pager-link"
                  (click)="primeraPagina(i)" [disabled]="paginaActual(i) <= 1"
                  aria-label="Primera página" title="Primera página">«</button>
                <button type="button" class="table-page__pager-link"
                  (click)="paginaAnterior(i)" [disabled]="paginaActual(i) <= 1"
                  aria-label="Página anterior" title="Página anterior">‹</button>

                <ng-container *ngFor="let page of getPaginationItems(i)">
                  <button *ngIf="isPageNumber(page)" type="button" class="table-page__pager-page"
                    [class.is-current]="page === paginaActual(i)"
                    (click)="irPagina(i, page)">{{ page }}</button>
                  <span *ngIf="!isPageNumber(page)" class="table-page__pager-ellipsis">...</span>
                </ng-container>

                <button type="button" class="table-page__pager-link"
                  (click)="paginaSiguiente(i)" [disabled]="paginaActual(i) >= totalPaginas(col)"
                  aria-label="Página siguiente" title="Página siguiente">›</button>
                <button type="button" class="table-page__pager-link"
                  (click)="ultimaPagina(i)" [disabled]="paginaActual(i) >= totalPaginas(col)"
                  aria-label="Última página" title="Última página">»</button>
              </div>
            </div>

            <div class="incidencias-board-page__column-body">
              <button
                type="button"
                class="incidencias-board-card is-clickable denuncias-kanban-page__card"
                *ngFor="let d of itemsPagina(col, i)"
                [draggable]="!esBloqueada(d)"
                [attr.title]="esBloqueada(d) ? 'Denuncia cerrada: no se puede reabrir ni mover' : null"
                (dragstart)="onDragStart(d)"
                (dragend)="draggingDenuncia = null"
                (click)="verDetalle(d)">
                <div class="incidencias-board-card__header">
                  <span
                    class="incidencias-board-card__ticket denuncias-kanban-page__ticket"
                    [style.backgroundColor]="col.color">
                    {{ d.codigoSeguimiento || 'Sin código' }}
                  </span>

                  <div class="incidencias-board-card__title-block">
                    <strong>{{ d.nombreCategoria || 'Sin categoría' }}</strong>
                    <div class="denuncias-kanban-page__subrow">
                      <span class="incidencias-board-card__date">
                        <i class="material-icons">calendar_today</i>
                        {{ d.fechaRegistro | date:'d MMM y' | titlecase }}
                      </span>
                      <span class="incidencias-board-card__meta denuncias-kanban-page__ver">
                        <i class="material-icons">visibility</i>
                        Ver detalle
                      </span>
                    </div>
                  </div>
                </div>

                <div class="incidencias-board-card__badges">
                  <span class="incidencias-board-card__badge denuncias-kanban-page__badge">
                    {{ getTipoLabel(d) }}
                  </span>
                  <span
                    class="incidencias-board-card__badge denuncias-kanban-page__badge denuncias-kanban-page__badge--bloqueada"
                    *ngIf="esBloqueada(d)">
                    <i class="material-icons">lock</i>
                    No editable
                  </span>
                </div>

                <p class="incidencias-board-card__description">
                  {{ getHechosResumen(d) }}
                </p>
              </button>

              <div class="table-page__empty-state incidencias-board-page__empty-column" *ngIf="col.lista.length === 0">
                <i class="material-icons">inventory_2</i>
                <p>Sin denuncias en esta columna.</p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</div>
